import 'consumerweb-shim';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import * as AppActions from '../../actions/AppActions';
import {
  localsMessages,
  isMobileHeaderExp,
} from '../../utility/getTemplateData';
import { hideSpinnerOverlay } from '../../utility/helper';
import Illustration from '../../components/illustrations/Illustration';
import ConfirmationTitle from '../../confirmation/ConfirmationTitle';
import ConfirmationBody from '../../confirmation/ConfirmationBody';

const landingMessages = localsMessages('errors/landingerror') || {};

class LandingErrorPage extends React.Component {
  componentDidMount() {
    AppActions.updateCurrentPage({ currentPage: 'landingError' });
    hideSpinnerOverlay();
  }

  handleReturn = () => {
    const linkpaypal =
      (landingMessages.link && landingMessages.link.paypal) || '';

    window.location.href = linkpaypal;
  };

  render() {
    const labelpaypal =
      (landingMessages.label && landingMessages.label.paypal) || '';
    const sessionexpired =
      (landingMessages.error && landingMessages.error.sessionexpired) || '';
    const startnewsession =
      (landingMessages.error && landingMessages.error.startnewsession) || '';

    return (
      <div>
        <div
          className={`donate_wrapper confirmation ${
            isMobileHeaderExp() ? 'mobile_view' : ''
          }`}
        >
          <div className="ppvx_row">
            <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
              <Illustration type="warning" />
            </div>
          </div>
          <div className="ppvx_row">
            <div className="ppvx_col-12 text-center">
              <ConfirmationTitle message={sessionexpired} />
            </div>
          </div>
          <div className="ppvx_row">
            <div className="ppvx_col-12 text-center">
              <ConfirmationBody message={startnewsession} />
            </div>
          </div>

          <div className="ppvx_row">
            <div className="ppvx_col-12 text-center">
              <a className="ppvx_link" onClick={this.handleReturn}>
                {labelpaypal}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ReactDOM.render(<LandingErrorPage />, document.getElementById('donateWrapper'));
